import Create from './create/CreateClientUsers';
import Individual from './individual/ClientUser';
import List from './list/ClientUsers';
import Edit from './edit/EditClientUser'

export default { List, Individual, Create, Edit };
